import { combineReducers } from 'redux';
import MapReducer from '../map/reducer';
import LangReducer from './lang';

const rootReducer = combineReducers({
    maps:MapReducer,
    layer:MapReducer,
    lang:LangReducer
});

export default rootReducer;
